module.exports = __webpack_public_path__ + "img/fwry.eee89a60.png";